/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalSettings
 */
export interface CarePrincipalSettings {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    puServiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    userManualUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    contractTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    contractLogo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettings
     */
    optInRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettings
     */
    exportDebitFormat?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettings
     */
    preliminaryStatusActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettings
     */
    exportCardsAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettings
     */
    puPresentation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettings
     */
    orderCardEnabled?: boolean;
}

export function CarePrincipalSettingsFromJSON(json: any): CarePrincipalSettings {
    return CarePrincipalSettingsFromJSONTyped(json, false);
}

export function CarePrincipalSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'puServiceId': !exists(json, 'puServiceId') ? undefined : json['puServiceId'],
        'userManualUrl': !exists(json, 'userManualUrl') ? undefined : json['userManualUrl'],
        'contractTemplate': !exists(json, 'contractTemplate') ? undefined : json['contractTemplate'],
        'contractLogo': !exists(json, 'contractLogo') ? undefined : json['contractLogo'],
        'optInRequired': !exists(json, 'optInRequired') ? undefined : json['optInRequired'],
        'exportDebitFormat': !exists(json, 'exportDebitFormat') ? undefined : json['exportDebitFormat'],
        'preliminaryStatusActive': !exists(json, 'preliminaryStatusActive') ? undefined : json['preliminaryStatusActive'],
        'exportCardsAutomatically': !exists(json, 'exportCardsAutomatically') ? undefined : json['exportCardsAutomatically'],
        'puPresentation': !exists(json, 'puPresentation') ? undefined : json['puPresentation'],
        'orderCardEnabled': !exists(json, 'orderCardEnabled') ? undefined : json['orderCardEnabled'],
    };
}

export function CarePrincipalSettingsToJSON(value?: CarePrincipalSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'puServiceId': value.puServiceId,
        'userManualUrl': value.userManualUrl,
        'contractTemplate': value.contractTemplate,
        'contractLogo': value.contractLogo,
        'optInRequired': value.optInRequired,
        'exportDebitFormat': value.exportDebitFormat,
        'preliminaryStatusActive': value.preliminaryStatusActive,
        'exportCardsAutomatically': value.exportCardsAutomatically,
        'puPresentation': value.puPresentation,
        'orderCardEnabled': value.orderCardEnabled,
    };
}

